import { KnowledgeBaseV2WithTags } from "@/generated";
import { IMenuEntry } from "../UI/NoxusMenu";
import { SpotToast } from "../SpotToast";
import { useSpotUser } from "@/utils/spotUser";
import { ExternalLink, Pencil, Trash2, Upload } from "lucide-react";
import { useExportEntity } from "@/hooks/useExportEntity";
import { WORKSPACE_PERMISSIONS } from "@/constants/permissions";

export const useKBsTableContextMenu = ({
  setDetailsModalOpen,
  setDeleteModalOpen,
  knowledgeBase,
}: {
  setDetailsModalOpen: (open: boolean) => void;
  setDeleteModalOpen: (open: boolean) => void;
  knowledgeBase: KnowledgeBaseV2WithTags | null;
}) => {
  const { mutate: exportKB } = useExportEntity({});

  const openKnowledgeBase = () => {
    if (knowledgeBase?.id) {
      window.open(
        `/data-hub/${knowledgeBase.id}`,
        "_blank",
        "noopener,noreferrer"
      );
    } else {
      SpotToast.error(
        "Could not open the knowledge base. Please try again later."
      );
    }
  };

  const getContextMenuItems = (
    knowledgeBase: KnowledgeBaseV2WithTags
  ): IMenuEntry[] => {
    const items: IMenuEntry[] = [
      {
        label: "Open in New Tab",
        onClick: openKnowledgeBase,
        icon: ExternalLink,
      },
      {
        label: "Edit Info",
        onClick: () => setDetailsModalOpen(true),
        auth: {
          level: "group",
          permissions: [WORKSPACE_PERMISSIONS.EDIT],
          requiresAllPermissions: false,
        },
        icon: Pencil,
      },
      {
        label: "Export",
        icon: Upload,
        auth: {
          level: "group",
          permissions: [WORKSPACE_PERMISSIONS.EDIT],
          requiresAllPermissions: false,
        },
        onClick: () =>
          exportKB({
            entityId: knowledgeBase.id,
            entityName: knowledgeBase.name,
            entityType: "kb",
          }),
      },
      {
        label: "Delete",
        onClick: () => {
          setDeleteModalOpen(true);
        },
        auth: {
          level: "group",
          permissions: [WORKSPACE_PERMISSIONS.DELETE],
          requiresAllPermissions: false,
        },
        color: "destructive",
        icon: Trash2,
      },
    ];

    return items;
  };

  return { getContextMenuItems };
};
